import React, { useState, useRef } from 'react';
import PropTypes from "prop-types";

const AgeInput = (props) => {
  const [value, setValue] = useState(props.default);
  const [buttonHeld, setButtonHeld] = useState(false);
  
  const autoChangeTimer = useRef(null);

  // Auto-increase function
  const startAutoIncrease = () => {
    setValue((val) => Math.min(val + 1, props.max));

    autoChangeTimer.current = setTimeout(() => {
      const increaseInterval = setInterval(() => {
        setValue((val) => Math.min(val + 1, props.max));
      }, 50);
      // Store the interval ID to clear it on button release
      setButtonHeld(increaseInterval);
    }, 500);
  };

  // Auto-decrease function
  const startAutoDecrease = () => {
    setValue((val) => Math.max(val - 1, props.min));

    autoChangeTimer.current = setTimeout(() => {
      const decreaseInterval = setInterval(() => {
        setValue((val) => Math.max(val - 1, props.min));
      }, 50);
      // Store the interval ID to clear it on button release
      setButtonHeld(decreaseInterval);
    }, 500);

  };

  // Event handlers for button clicks
  const handleIncreaseClick = () => { startAutoIncrease(); };

  const handleDecreaseClick = () => { startAutoDecrease(); };
    
  // Event handler for button release
  const handleButtonRelease = () => {
    clearTimeout(autoChangeTimer.current);
    clearInterval(buttonHeld);
    setButtonHeld(false);

    props.updateValue(value);
  };
    

  return <>
      <button
        type = 'button'
        className = "bi bi-chevron-up btn fs-2 d-block border-0 mx-auto link-light"
        onMouseDown = { handleIncreaseClick }
        onMouseUp = { handleButtonRelease }
      >
      </button>
      <h1>{ value }</h1>
      <button
        type = 'button'
        className = "bi bi-chevron-down btn fs-2 d-block border-0 mx-auto link-light"
        onMouseDown = { handleDecreaseClick }
        onMouseUp = { handleButtonRelease }
      >
      </button>
  </>;
};

AgeInput.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    default: PropTypes.number,
    updateValue: PropTypes.func
};

export default AgeInput;